<template>
    <div>
        <loading-custom :loading="loading" />
        <div v-if="transport_type == 'create' || transport_type == 'edit'">
            <div class="card">
                <div class="tab-content">
                    <div class="tab-pane active">
                        <form @submit.prevent="handleSubmit()">
                            <div class="body">
                                <div class="row clearfix">
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label class="tw-ml-2">
                                                ชื่อขนส่ง
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="ชื่อขนส่ง"
                                                v-model="form.name"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="tw-ml-2">
                                                รายละเอียดขนส่ง
                                            </label>
                                            <textarea
                                                class="form-control"
                                                v-model="form.description"
                                                placeholder="รายละเอียด"
                                                cols="30"
                                                rows="10"
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="action-btn" class="body">
                                <div class="tw-w-full text-right">
                                    <button class="btn btn-sm btn-success">
                                        บันทึก
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-default tw-ml-1"
                                        @click="cancel()"
                                    >
                                        ย้อนกลับ
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="!status.transport" class="table-responsive">
            <table class="table table-hover mb-0 c_list">
                <thead>
                    <tr>
                        <th class="tw-w-4/12">ชื่อขนส่ง</th>
                        <th class="tw-w-3/12">คำอธิบาย</th>
                        <th class="text-right">ACTION</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-if="
                            tableData.data ? tableData.data.length === 0 : true
                        "
                    >
                        <td class="text-center" colspan="3">
                            ไม่พบข้อมูล
                        </td>
                    </tr>
                    <tr v-for="(item, index) in tableData.data" :key="index">
                        <td>
                            {{ item.name }}
                        </td>
                        <td class="tw-w-80">
                            <div class="tw-w-80 text-ellipsis">
                                {{ item.description }}
                            </div>
                        </td>
                        <td class="text-right">
                            <button
                                @click="editData(item)"
                                type="button"
                                class="btn btn-sm btn-warning"
                                title="Edit"
                            >
                                <i class="fa fa-edit"> แก้ไข</i>
                            </button>
                            <button
                                @click="confirmDelete(item.id)"
                                type="button"
                                data-type="confirm"
                                class="btn btn-sm btn-danger js-sweetalert"
                                title="Delete"
                            >
                                <i class="fa fa-trash-o"> ลบ</i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<style scoped>
.text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
<script>
export default {
    props: {
        shop: {
            default: "",
            type: String,
            required: true
        },
        transport_type: {
            type: String
        },
        transport_edit:{
          require: false
        },
        transport_data: {
            default: {}
        }
    },
    data() {
        return {
            loading: false,
            form: {},
            tableData: {},
            type: "",
            status: {
                transport: false
            }
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData(data = "") {
            this.loading = await true;
            if (data) {
                this.tableData.data = await data;
            } else {
                this.tableData.data = await this.transport_data;
            }

            if (this.transport_type == 'edit' && this.transport_edit) {
              this.form = this.transport_edit
            }
            this.loading = await false;
        },
        editData(data) {
            window.location.href = `/backend/s/${this.shop}/transport/${data.id}/edit`;
            // this.status.transport = true;
            // this.type = "edit";
            // this.form = data;
        },
        handleSubmit() {
            if (this.transport_type == "create") {
                this.store();
            } else if (this.transport_type == "edit") {
                this.update();
            }
        },
        async store() {
            this.loading = true;
            await axios
                .post(`/backend/s/${this.shop}/transport`, this.form)
                .then(res => {
                    this.cancel();
                    this.getData(res.data.transport);
                    this.loading = false;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "Sorry",
                        "กรุณาใส่ข้อมูลให้ครบถ้วน"
                    );
                });
        },
        async update() {
            this.loading = true;
            await axios
                .patch(
                    `/backend/s/${this.shop}/transport/${this.form.id}`,
                    this.form
                )
                .then(res => {
                    this.cancel();
                    this.getData(res.data.transport);
                    this.loading = false;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "ขอโทษค่ะ",
                        "กรุณาใส่ข้อมูลให้ครบถ้วนก่อนทำการบันทึกข้อมูล"
                    );
                });
        },
        confirmDelete(id) {
            this.$swal({
                icon: "warning",
                title: "ต้องการลบรายการขนส่งนี้ใช่หรือไม่?",
                text: "เมื่อกดยืนยัน ข้อมูลนี้จะถูกลบ",
                confirmButtonText: "ยืนยัน",
                showCancelButton: true,
                cancelButtonText: "ยกเลิก",
                reverseButtons: true
            }).then(result => {
                if (result.isConfirmed) {
                    this.deleteData(id);
                }
            });
        },
        async deleteData(id) {
            this.loading = true;
            await axios
                .delete(`/backend/s/${this.shop}/transport/${id}`)
                .then(res => {
                    this.getData(res.data.transport_data);
                })
                .catch(err => {})
                .then(() => {
                    this.loading = false;
                });
        },
        cancel() {
            // this.type = "";
            // this.status.transport = false;
            // this.form = {};
            window.location.href = `/backend/s/${this.shop}/transport`;
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        }
    }
};
</script>
